var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "app--main"
  }, [_c('main-visual'), _c('section', {
    staticClass: "main-section main-section--service pb-0"
  }, [_c('div', {
    staticClass: "tit-wrap tit-wrap--center"
  }, [_c('v-img', {
    staticClass: "tit-wrap__img",
    attrs: {
      "src": "/images/common/tit-img.png"
    }
  }), _c('h2', {
    staticClass: "tit tit--xl mb-24",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Service")]), _c('p', {
    staticClass: "page-text page-text--lg font-weight-medium",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "100"
    }
  }, [_vm._v("(주)모두에프엔티의 모토는 최고의 상품과 최상의 마켓정보를 통해 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("고객 분들께 최선의 서비스를 제공하는 것 입니다.")])], 1), _c('v-card', {
    staticClass: "service-card white--text",
    attrs: {
      "flat": "",
      "tile": ""
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('router-link', {
    staticClass: "service-card__link b-right b-bottom",
    attrs: {
      "align": "center",
      "to": "/company/greeting"
    }
  }, [_c('div', {
    staticClass: "service-card__inner"
  }, [_c('p', {
    staticClass: "page-text page-text--xs mb-12",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("About")]), _c('h3', {
    staticClass: "tit",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" 회사소개 ")]), _c('v-btn', {
    staticClass: "rounded-lg",
    attrs: {
      "fab": "",
      "color": "secondary"
    }
  }, [_c('v-icon', [_vm._v("mdi-plus")])], 1)], 1)])], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('router-link', {
    staticClass: "service-card__link b-bottom b-right--md",
    attrs: {
      "align": "center",
      "to": "/business/overview"
    }
  }, [_c('div', {
    staticClass: "service-card__inner"
  }, [_c('p', {
    staticClass: "page-text page-text--xs mb-12",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Business")]), _c('h3', {
    staticClass: "tit",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" 사업개요 ")]), _c('v-btn', {
    staticClass: "rounded-lg",
    attrs: {
      "fab": "",
      "color": "secondary"
    }
  }, [_c('v-icon', [_vm._v("mdi-plus")])], 1)], 1)])], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('router-link', {
    staticClass: "service-card__link b-right",
    attrs: {
      "align": "center",
      "to": "/product"
    }
  }, [_c('div', {
    staticClass: "service-card__inner"
  }, [_c('p', {
    staticClass: "page-text page-text--xs mb-12",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Products")]), _c('h3', {
    staticClass: "tit",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" 제품안내 ")]), _c('v-btn', {
    staticClass: "rounded-lg",
    attrs: {
      "fab": "",
      "color": "secondary"
    }
  }, [_c('v-icon', [_vm._v("mdi-plus")])], 1)], 1)])], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('router-link', {
    staticClass: "service-card__link",
    attrs: {
      "align": "center",
      "to": "/service/inquiry"
    }
  }, [_c('div', {
    staticClass: "service-card__inner"
  }, [_c('p', {
    staticClass: "page-text page-text--xs mb-12",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v("Contact us")]), _c('h3', {
    staticClass: "tit",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" 고객센터 ")]), _c('v-btn', {
    staticClass: "rounded-lg",
    attrs: {
      "fab": "",
      "color": "secondary"
    }
  }, [_c('v-icon', [_vm._v("mdi-plus")])], 1)], 1)])], 1)], 1)], 1)], 1), _c('section', {
    staticClass: "main-section main-section--products"
  }, [_c('v-container', [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "tit-wrap main-section--products__tit"
  }, [_c('v-img', {
    staticClass: "tit-wrap__img",
    attrs: {
      "src": "/images/common/tit-img.png"
    }
  }), _c('h2', {
    staticClass: "tit tit--xl",
    attrs: {
      "data-aos": "fade-right"
    }
  }, [_vm._v("Products")])], 1), _c('div', {
    staticClass: "swiper-nav"
  }, [_c('div', {
    staticClass: "swiper-button-prev"
  }, [_c('icon-arrow-rounded', {
    staticClass: "grey--text text--darken-4 icon--size-x-large",
    attrs: {
      "direction": "left"
    }
  })], 1), _c('span', {
    staticClass: "swiper-nav__line"
  }), _c('div', {
    staticClass: "swiper-button-next"
  }, [_c('icon-arrow-rounded', {
    staticClass: "grey--text text--darken-4 icon--size-x-large",
    attrs: {
      "direction": "right"
    }
  })], 1)])]), _c('v-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('div', {
    staticClass: "products-slide"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    staticClass: "mb-16 mb-md-32",
    attrs: {
      "src": "/images/main/product01.png"
    }
  }), _c('div', {
    staticClass: "tit-wrap tit-wrap--xs"
  }, [_c('h3', {
    staticClass: "tit tit--sm"
  }, [_vm._v(" 소스류 [OEM 가능] ")])]), _c('p', {
    staticClass: "page-text page-text--sm grey--text mb-16 mb-md-32"
  }, [_vm._v(" 업소용 케첩&마요네즈, 돈까스소스, 떡볶이 소스, 쫄면장 소스, "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 콘버터용 소스, 간장소스, 우동소스, 각종 샐러드 드레싱, 각종 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 과일 잼 등, OEM 소스 생산 MOQ 200kg이상 ")]), _c('v-btn', {
    staticClass: "rounded-lg",
    attrs: {
      "fab": "",
      "outlined": "",
      "color": "secondary",
      "to": "/product#1"
    }
  }, [_c('icon-arrow-rounded', {
    staticClass: "icon--size-small",
    attrs: {
      "direction": "right"
    }
  })], 1)], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    staticClass: "mb-16 mb-md-32",
    attrs: {
      "src": "/images/main/product02.png"
    }
  }), _c('div', {
    staticClass: "tit-wrap tit-wrap--xs"
  }, [_c('h3', {
    staticClass: "tit tit--sm"
  }, [_vm._v(" 제과제빵류 ")])]), _c('p', {
    staticClass: "page-text page-text--sm grey--text mb-16 mb-md-32"
  }, [_vm._v(" 각종 페스츄리 생지, 크로와상 생지 (미니 사이즈도 보유), 데니쉬 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 파이 생지, 애플 코로네 생지 , 뺑오 쇼콜라 생지, 베이글 등 ")]), _c('v-btn', {
    staticClass: "rounded-lg",
    attrs: {
      "fab": "",
      "outlined": "",
      "color": "secondary",
      "to": "/product#2"
    }
  }, [_c('icon-arrow-rounded', {
    staticClass: "icon--size-small",
    attrs: {
      "direction": "right"
    }
  })], 1)], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    staticClass: "mb-16 mb-md-32",
    attrs: {
      "src": "/images/main/product03.png"
    }
  }), _c('div', {
    staticClass: "tit-wrap tit-wrap--xs"
  }, [_c('h3', {
    staticClass: "tit tit--sm"
  }, [_vm._v(" 공산품식자재류 ")])]), _c('p', {
    staticClass: "page-text page-text--sm grey--text mb-16 mb-md-32"
  }, [_vm._v(" 밀가루, 참기름, 식용유, 들기름, 식초, 액젓, 설탕 등 ")]), _c('v-btn', {
    staticClass: "rounded-lg",
    attrs: {
      "fab": "",
      "outlined": "",
      "color": "secondary",
      "to": "/product#3"
    }
  }, [_c('icon-arrow-rounded', {
    staticClass: "icon--size-small",
    attrs: {
      "direction": "right"
    }
  })], 1)], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    staticClass: "mb-16 mb-md-32",
    attrs: {
      "src": "/images/main/product04.png"
    }
  }), _c('div', {
    staticClass: "tit-wrap tit-wrap--xs"
  }, [_c('h3', {
    staticClass: "tit tit--sm"
  }, [_vm._v(" 파스타면 외 면류 ")])]), _c('p', {
    staticClass: "page-text page-text--sm grey--text mb-16 mb-md-32"
  }, [_vm._v(" 파스타 면, 스파게티 면, 페투치니 면. 라면사리, 칼국수 사리, 쫄면 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 사리 등 ")]), _c('v-btn', {
    staticClass: "rounded-lg",
    attrs: {
      "fab": "",
      "outlined": "",
      "color": "secondary",
      "to": "/product#5"
    }
  }, [_c('icon-arrow-rounded', {
    staticClass: "icon--size-small",
    attrs: {
      "direction": "right"
    }
  })], 1)], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    staticClass: "mb-16 mb-md-32",
    attrs: {
      "src": "/images/main/product05.png"
    }
  }), _c('h3', {
    staticClass: "tit tit--sm mb-12"
  }, [_vm._v(" 치즈 및 유제품류 ")]), _c('p', {
    staticClass: "page-text page-text--sm grey--text mb-16 mb-md-32"
  }, [_vm._v(" 체다치즈, 고르곤졸라 치즈, 아이스크림 믹스, 연유, 휘핑크림 등 ")]), _c('v-btn', {
    staticClass: "rounded-lg",
    attrs: {
      "fab": "",
      "outlined": "",
      "color": "secondary",
      "to": "/product#4"
    }
  }, [_c('icon-arrow-rounded', {
    staticClass: "icon--size-small",
    attrs: {
      "direction": "right"
    }
  })], 1)], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    staticClass: "mb-16 mb-md-32",
    attrs: {
      "src": "/images/main/product06.png"
    }
  }), _c('h3', {
    staticClass: "tit tit--sm mb-12"
  }, [_vm._v(" 냉동/냉장가공 식품류 ")]), _c('p', {
    staticClass: "page-text page-text--sm grey--text mb-16 mb-md-32"
  }, [_vm._v(" 냉동만두, 볶음밥, 냉동 수산물, 냉동 홍시, 락교, 동그랑땡, 돈까스, "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 치킨까스, 오징어 링, 새우 튀김 등 ")]), _c('v-btn', {
    staticClass: "rounded-lg",
    attrs: {
      "fab": "",
      "outlined": "",
      "color": "secondary",
      "to": "/product#6"
    }
  }, [_c('icon-arrow-rounded', {
    staticClass: "icon--size-small",
    attrs: {
      "direction": "right"
    }
  })], 1)], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    staticClass: "mb-16 mb-md-32",
    attrs: {
      "src": "/images/main/product07.png"
    }
  }), _c('h3', {
    staticClass: "tit tit--sm mb-12"
  }, [_vm._v(" 육가공류 및 포장육류 ")]), _c('p', {
    staticClass: "page-text page-text--sm grey--text mb-16 mb-md-32"
  }, [_vm._v(" 함박 스테이크, 베이컨, 바베큐폴드포크, 오리슬라이스, 모듬 "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 소세지, 데리야키 치킨, 불고기 등 ")]), _c('v-btn', {
    staticClass: "rounded-lg",
    attrs: {
      "fab": "",
      "outlined": "",
      "color": "secondary",
      "to": "/product#7"
    }
  }, [_c('icon-arrow-rounded', {
    staticClass: "icon--size-small",
    attrs: {
      "direction": "right"
    }
  })], 1)], 1), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    staticClass: "mb-16 mb-md-32",
    attrs: {
      "src": "/images/main/product08.png"
    }
  }), _c('h3', {
    staticClass: "tit tit--sm mb-12"
  }, [_vm._v(" 야채/신선식품류 ")]), _c('p', {
    staticClass: "page-text page-text--sm grey--text mb-16 mb-md-32"
  }, [_vm._v(" 배추, 양배추, 양파, 대파, 깻잎, 무, 고구마, 토마토, 단호박, "), _c('br', {
    staticClass: "d-none d-xl-block"
  }), _vm._v(" 아스파라거스 등 가락시장에서 직접 입찰해 공수 ")]), _c('v-btn', {
    staticClass: "rounded-lg",
    attrs: {
      "fab": "",
      "outlined": "",
      "color": "secondary",
      "to": "/product#8"
    }
  }, [_c('icon-arrow-rounded', {
    staticClass: "icon--size-small",
    attrs: {
      "direction": "right"
    }
  })], 1)], 1)])])])])], 1)], 1)], 1), _c('section', {
    staticClass: "main-section main-section--contact pt-0"
  }, [_c('div', {
    staticClass: "h-300px h-lg-600px"
  }, [_c('iframe', {
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "src": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3164.1213528284475!2d127.22307098860779!3d37.52863656001022!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357cb23ba131d1cf%3A0x426f880eb3cef2dd!2z6rK96riw64-EIO2VmOuCqOyLnCDssL3smrDroZwgMzgtMzU!5e0!3m2!1sko!2skr!4v1687430444070!5m2!1sko!2skr",
      "width": "100%",
      "height": "100%",
      "allowfullscreen": "",
      "loading": "lazy",
      "referrerpolicy": "no-referrer-when-downgrade"
    }
  })]), _c('v-container', {
    staticClass: "mt-n60 mt-lg-n172",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('v-card', {
    staticClass: "white--text",
    attrs: {
      "flat": "",
      "color": "primary darken-4"
    }
  }, [_c('div', {
    staticClass: "px-20 py-50 py-md-74 pa-lg-100"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "tit-wrap mb-20 mb-md-0"
  }, [_c('v-img', {
    staticClass: "tit-wrap__img",
    attrs: {
      "src": "/images/common/tit-img-white.png"
    }
  }), _c('h3', {
    staticClass: "tit tit--xl"
  }, [_vm._v(" Contact Us ")])], 1)]), _c('v-col', {
    staticClass: "line-height-11",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('p', {
    staticClass: "page-text page-text--lg font-weight-bold w-120px w-lg-160px mb-6 mb-md-0"
  }, [_vm._v(" Address ")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('p', {
    staticClass: "page-text page-text--lg font-weight-medium"
  }, [_vm._v(" 경기도 하남시 창우로 38-35번지 ")])])], 1)], 1), _c('div', {
    staticClass: "mt-16 mt-md-24 mt-md-32"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('p', {
    staticClass: "page-text page-text--lg font-weight-bold w-120px w-lg-160px mb-6 mb-md-0"
  }, [_vm._v(" Tel ")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('p', {
    staticClass: "page-text page-text--lg font-weight-medium"
  }, [_vm._v(" 02-487-7350 ")])])], 1)], 1), _c('div', {
    staticClass: "mt-16 mt-md-24 mt-md-32"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('p', {
    staticClass: "page-text page-text--lg font-weight-bold w-120px w-lg-160px mb-6 mb-md-0"
  }, [_vm._v(" Fax ")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('p', {
    staticClass: "page-text page-text--lg font-weight-medium"
  }, [_vm._v(" 02-486-2189 ")])])], 1)], 1), _c('div', {
    staticClass: "mt-16 mt-md-24 mt-md-32"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('p', {
    staticClass: "page-text page-text--lg font-weight-bold w-120px w-lg-160px mb-6 mb-md-0"
  }, [_vm._v(" E-mail ")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('p', {
    staticClass: "page-text page-text--lg font-weight-medium"
  }, [_vm._v(" MODOO456@naver.com ")])])], 1)], 1)])], 1)], 1)])], 1)], 1), _c('popup-layer')], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }